import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule } from '@nebular/theme';
import { Turma } from '../../core/api/turma';
import { TurmaUsuarioService } from '../../core/api/turma-usuario.service';
import { formatarHoraSomenteHm } from '../../utils/formatar-hora-hm';
import { ListaVaziaComponent } from '../../shared/lista-vazia/lista-vazia.component';

import { AutocompleteComponent, OpcaoAutocomplete } from '../../shared/autocomplete/autocomplete.component';
import { BarraCarregandoComponent } from '../../shared/barra-carregando/barra-carregando.component';
import { finalize } from 'rxjs/operators';
import { Ordenacao, OrdenavelComponent } from '../../shared/ordenavel/ordenavel.component';
import { ordenarEmMemoria } from '../../utils/ordenar-em-memoria';
@Component({
  selector: 'app-minhas-turmas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbButtonModule,
    NbIconModule,
    NbFormFieldModule,
    NbInputModule,
    ListaVaziaComponent,
    AutocompleteComponent,
    BarraCarregandoComponent,
    OrdenavelComponent,
  ],
  templateUrl: './minhas-turmas.component.html',
  styleUrl: './minhas-turmas.component.scss',
})
export class MinhasTurmasComponent implements OnInit {
  /** Lista completa vindas da API */
  turmas: Turma[] = [];
  carregando = false;
  turmaFiltroId = '';
  readonly formatarHoraHm = formatarHoraSomenteHm;

  constructor(
    private turmaUsuarioService: TurmaUsuarioService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.carregando = true;
    this.turmaUsuarioService
      .minhasTurmas()
      .pipe(finalize(() => (this.carregando = false)))
      .subscribe({
        next: (t) => {
          this.turmas = t ?? [];
        },
      });
  }

  /** `TAB-12` — o recorte aqui vem do seletor de turma, não de caixa de busca. */
  get temFiltro(): boolean {
    return !!this.turmaFiltroId;
  }

  limparFiltro(): void {
    this.turmaFiltroId = '';
  }

  /**
   * `TAB-01` — ordenação em memória, legítima aqui: `GET /turmas-usuario/minhas` devolve a
   * coleção inteira. A ordenação vem **depois** do recorte, senão ordenaria o que não se vê.
   */
  ordenacao: Ordenacao | null = null;

  ordenarPor(o: Ordenacao): void {
    this.ordenacao = o;
  }

  get turmasExibidas(): Turma[] {
    const recortadas = this.turmaFiltroId
      ? this.turmas.filter((x) => x.id === this.turmaFiltroId)
      : this.turmas;
    return ordenarEmMemoria(recortadas, this.ordenacao, (item, campo) =>
      (item as unknown as Record<string, unknown>)[campo],
    );
  }

  labelTurma(t: Turma): string {
    const n = (t.nome ?? '').trim();
    const a = t.ano != null ? ` (${t.ano})` : '';
    const q = t.quantidadeMatriculas != null ? ` (${t.quantidadeMatriculas})` : '';
    return `${n}${a}${q}`;
  }

  /** `FRM-01` — o recorte por turma é autocomplete, sobre as turmas do próprio usuário. */
  get opcoesTurma(): OpcaoAutocomplete[] {
    return this.turmas.map((t) => ({ id: t.id ?? '', rotulo: this.labelTurma(t) }));
  }

  trackByTurmaId = (_: number, t: Turma): string => t.id ?? '';

  irFrequencia(turmaId: string | undefined): void {
    if (turmaId) this.router.navigate(['/frequencia', turmaId]);
  }

  irFaltasConsolidado(turmaId: string | undefined): void {
    if (turmaId) this.router.navigate(['/frequencia', turmaId, 'faltas-consolidado']);
  }

  /** Horário em linha abaixo do nome (sem negrito); — quando vazio. */
  textoHorarioTurma(t: Turma): string {
    if (!t.diaSemana && !t.horarioInicio) {
      return '—';
    }
    const partes: string[] = [];
    if (t.diaSemana) partes.push(String(t.diaSemana).trim());
    const hi = this.formatarHoraHm(t.horarioInicio);
    if (hi) partes.push(hi);
    let s = partes.join(' ').trim();
    const hf = this.formatarHoraHm(t.horarioFim);
    if (hf) {
      s = s ? `${s} –${hf}` : `–${hf}`;
    }
    return s.trim() || '—';
  }
}
